/**
 * Construction ERP - Responsive Table Card View Helper
 * Automatically extracts <th> column labels and sets data-label attributes
 * on every corresponding <td>, enabling seamless mobile & tablet card views.
 */

let observer = null;
let scheduled = false;

function applyTableLabels() {
  scheduled = false;
  const tables = document.querySelectorAll('table:not(.cal-table):not(.cal-grid)');
  tables.forEach((table) => {
    // Extract column headers from thead
    const ths = Array.from(table.querySelectorAll('thead th, thead td'));
    if (!ths.length) return;

    const headers = ths.map((th) => {
      const clone = th.cloneNode(true);
      // Remove sort icons, badges or action svgs from the header text
      clone.querySelectorAll('svg, .sort-icon, [class*="sort"], button').forEach((el) => el.remove());
      return clone.textContent.trim();
    });

    // Populate data-label on each cell in every tbody row
    const rows = table.querySelectorAll('tbody tr');
    rows.forEach((row) => {
      // Skip empty state placeholder rows with colSpan
      if (row.querySelector('.no-data, td[colspan]')) return;

      const tds = Array.from(row.querySelectorAll('td'));
      tds.forEach((td, idx) => {
        if (!td.getAttribute('data-label') && headers[idx]) {
          td.setAttribute('data-label', headers[idx]);
        }
      });
    });
  });
}

export function initResponsiveTableObserver() {
  if (typeof window === 'undefined') return;

  // Run on initial load
  applyTableLabels();

  // Debounced execution for DOM updates (route changes, pagination, modal tables)
  const scheduleApply = () => {
    if (!scheduled) {
      scheduled = true;
      requestAnimationFrame(applyTableLabels);
    }
  };

  if (!observer) {
    observer = new MutationObserver((mutations) => {
      let hasTableChange = false;
      for (const mutation of mutations) {
        if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
          hasTableChange = true;
          break;
        }
      }
      if (hasTableChange) {
        scheduleApply();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }

  // Also hook into popstate and pushstate for route changes
  window.addEventListener('popstate', scheduleApply);

  return () => {
    if (observer) {
      observer.disconnect();
      observer = null;
    }
    window.removeEventListener('popstate', scheduleApply);
  };
}
